import { render } from "./MyApplications.vue?vue&type=template&id=56397f19&scoped=true"
import script from "./MyApplications.vue?vue&type=script&lang=js"
export * from "./MyApplications.vue?vue&type=script&lang=js"

import "./MyApplications.vue?vue&type=style&index=0&id=56397f19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56397f19"]])

export default __exports__